import React from 'react';
import ScreenWrapper from '../features/Theme/ScreenWrapper';
import AddFundsAlternativePayment from '../features/AddFundsAlternativePayment';

type Props = {
    provider?: string;
    currentAmount?: string;
    setActiveRightTab?: Function;
};

export default function AddFundsAlternativePaymentScreen({ provider, currentAmount, setActiveRightTab }: Props) {
    return (
        <ScreenWrapper>
            <AddFundsAlternativePayment
                provider={provider}
                currentAmount={currentAmount}
                setActiveRightTab={setActiveRightTab}
            />
        </ScreenWrapper>
    );
}
